import React from 'react'
import Button from '../../../../designSystem/Buttons/Index'

const IAWellnessSection = () => {
  return (
    <div className='il-ia-wellness-section'>
      <div className="il-ia-wellness-section-left">
        <h1>Maximiza la eficacia de tus programas de bienestar con IA</h1>
        <p>Cuidar la salud mental de tus colaboradores es <b>mucho más que entregar beneficios de consultas de psicología</b>. Con Terapi, podrás construir <b>programas de bienestar institucionales</b>  que realmente cuiden el bienestar mental y emocional de tus colaboradores. Con ayuda de nuestra <b>IA</b>, construye el programa más efectivo para tu empresa.</p>
        <Button
          type='fill'
          color='accent'
          text='Agenda una demo'
          onClickHandler={() => window.location.href = `/${document.body.dataset.site}/empresas#contact-section`}
        />
      </div>
      <div className="il-ia-wellness-section-right">
        
      </div>
    </div>
  )
}

export default IAWellnessSection